export const validateMeasure = (metric, measurement) => {
  if (metric === 'bp') {
    return ('systolic' in measurement && 'diastolic' in measurement);
  } else if (metric === 'glucose') {
    return ('glucose' in measurement);
  } else if (metric === 'temp') {
    return ('bodyTemperature' in measurement);
  } else if (metric === 'pulse') {
    return ('pulse' in measurement);
  } else if (metric === 'oxygen') {
    return ('bloodOxygen' in measurement);
  }
}